import styled from 'styled-components';

export const StyledContent = styled.div`
  .title.with-error {
    margin-bottom: 16px;
  }

  .identity__password-success-info {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .identity__field {
    margin: 0 0 16px 0;

    &.password-confirm {
      margin: 0 0 40px 0;
    }

    &.with-error {
      margin-bottom: 44px;
      &.password-confirm {
        margin-bottom: 68px;
      }
    }
  }
  .identity__password-policy {
    margin-top: 16px;
    font-weight: bold;
    margin-bottom: 16px;
  }
  .identity__password-hits-wrapper {
    margin-top: 10px;
  }
`;

export const PasswordValidationHint = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 16px;
  }
`;

export const PasswordHint = styled.li`
  padding-left: 8px;
`;

export const Centered = styled.div`
  margin: auto;
`;
